import List from '@mui/material/List';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FieldPath, useController } from 'react-hook-form';

import { GetPackagesResult } from 'api/hooks/public/useGetPackages';

import { RegistrationFormOutputValues } from '../utils/validationSchema';
import SectionListItem from './SectionListItem';

interface PropTypes {
  name: FieldPath<RegistrationFormOutputValues>;
  sections: GetPackagesResult['courses'][0]['sections'];
}

function SectionList({ name, sections }: PropTypes) {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const { field } = useController<RegistrationFormOutputValues>({ name: name });

  return (
    <Paper
      style={{
        maxHeight: isMd ? 500 : undefined,
        overflow: isMd ? 'auto' : 'visible',
      }}
    >
      <List>
        {sections?.map((section) => (
          <SectionListItem
            key={section.id}
            section={section}
            selected={field.value === section.id}
            onSelect={field.onChange}
          />
        ))}
      </List>
    </Paper>
  );
}

export default SectionList;
